import React, { forwardRef } from 'react';
import styled from 'styled-components';

const VehicleSearchSvg = styled.svg`
  fill: none;
  height: 52px;
  width: 52px;
`;

type OwnProps = React.SVGProps<SVGSVGElement>;

const VehicleSearch = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <VehicleSearchSvg viewBox="0 0 52 52" ref={ref} {...props}>
    <path
      d="M37.5744 37.8617L50.6985 50.9861"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle
      cx="22.5755"
      cy="22.8617"
      r="20.8753"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      d="M10.0944 33.1273H27.0645C28.169 33.1273 29.0645 32.2319 29.0645 31.1273V22.909C29.0645 22.3786 28.8537 21.8699 28.4787 21.4948L26.0417 19.0578C25.7735 18.7897 25.5872 18.4509 25.5043 18.0809L23.9411 11.1042C23.7364 10.1908 22.9255 9.5415 21.9894 9.5415H13.9873"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M28.6233 15.2716L28.6236 14.2716L28.6233 15.2716ZM7.35066 19.8284C6.79838 19.8284 6.35066 19.3807 6.35066 18.8284C6.35066 18.2761 6.79838 17.8284 7.35066 17.8284V19.8284ZM14.1499 17.8284H28.623V19.8284H14.1499V17.8284ZM28.623 17.8284V16.2716H30.623V17.8284H28.623ZM28.623 16.2716L24.5421 16.2705L24.5426 14.2705L28.6236 14.2716L28.623 16.2716ZM14.1499 19.8284H7.35066V17.8284H14.1499V19.8284ZM28.623 17.8284L28.623 17.8284H30.623C30.623 18.9329 29.7276 19.8284 28.623 19.8284V17.8284ZM28.623 16.2716V16.2716L28.6236 14.2716C29.7279 14.2719 30.623 15.1672 30.623 16.2716H28.623Z"
      fill="#00AED9"
    />
    <circle
      r="2.77321"
      transform="matrix(-1 0 0 1 23.1467 26.3396)"
      stroke="#00AED9"
      strokeWidth="2"
    />
    <path
      d="M26.0059 36.7393V37.8243C26.0059 38.3766 25.5581 38.8243 25.0059 38.8243H22.1081C21.5558 38.8243 21.1081 38.3766 21.1081 37.8243V36.7393"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M8.46289 26.1309C7.91061 26.1309 7.46289 26.5786 7.46289 27.1309C7.46289 27.6831 7.91061 28.1309 8.46289 28.1309V26.1309ZM16.8173 28.1309C17.3696 28.1309 17.8173 27.6831 17.8173 27.1309C17.8173 26.5786 17.3696 26.1309 16.8173 26.1309V28.1309ZM8.46289 28.1309H16.8173V26.1309H8.46289V28.1309Z"
      fill="#00AED9"
    />
  </VehicleSearchSvg>
));

export default VehicleSearch;
